module.exports = __webpack_public_path__ + "img/content-8.a4ccff3.png";